<script setup lang="ts">

import ToastItem from '@/components/Interface/Toast/ToastItem.vue'

const props = defineProps<{
  toast: boolean,
  toastImage: string,
  toastText: string,
}>();

</script>

<template>
  <div v-if="props.toast">
    <ToastItem>
      <template #image>
        <img
          :src="toastImage"
          class="rounded h-16 w-16"
          alt=""
        />
      </template>
      <template #text>
        {{ toastText }}
      </template>
    </ToastItem>
  </div>
  <div v-else>
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">

</style>